import { lazy } from '@atlassian/react-loosely-lazy';
import type { InlineResolutionEdit } from './ui/edit/inline/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const AsyncInlineResolutionEdit = lazy<typeof InlineResolutionEdit>(() =>
	import(/* webpackChunkName: "async-jira-issue-field-inline-resolution-edit" */ './index').then(
		(module) => module.InlineResolutionEdit,
	),
);
